<form role="form" [formGroup]="validationResultForm">
  <p style="display: none;">{{title}}</p>
  <div class="row">
      <div class="row text-center">
          <div class="col-sm-12 col-md-9">
              <div class="entradas-de-texto-govco">
                  <div class="container-input-texto-govco">
                      <select class="form-select" id="Negadodocumentos" aria-label="Default select example"
                              formControlName="statusId"
                              [ngClass]="{'error': isTouchedField(validationResultForm, 'statusId')}"
                              aria-describedby="typeNegadodocumentoslId-note">
                         <option disabled selected value="">Seleccionar</option>
                         <option *ngFor="let item of listStatus let i = index" [value]="item.id">{{item.description}}</option>
                      </select>
                    <span
                      class="error-texto-govco alert-entradas-de-texto-govco"
                      id="statusId-note" role="alert" aria-live="assertive">
                      {{ getErrorMessage('statusId') }}
                    </span>
                  </div>
              </div>
          </div>

          <div class="col-sm-12 col-md-3">
              <span (click)="seguimiento(tramiteObject.id)" data-bs-toggle="modal"  data-bs-target="#seguimiento-auditoria" class="govco-address-card-1" style="font-size: 30px; color: #3366cc; cursor: pointer;"></span>
              <br />
              Seguimiento Auditoria

              <!-- Modal -->
              <div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="seguimiento-auditoria" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered modal-xl">
                      <div class="modal-content">
                          <div class="modal-header">
                              <h5 class="modal-title" id="exampleModalLabel">Tabla de seguimiento</h5>
                              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                          </div>
                          <div class="modal-body">
                              <table class="table" aria-describedby="mydesc">
                                  <thead>
                                      <tr>
                                          <th>Fecha Seguimiento</th>
                                          <th>Usuario</th>
                                          <th>Estado</th>
                                          <th>Observación</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                    <tr *ngFor="let item of statusName let i = index">
                                      <td>{{item.registrationDate | date: 'dd/MM/yyyy hh:mm a'}}</td>
                                      <td>{{mostrarIniciales(item.fullName)}}</td>
                                      <td>{{item.status}}</td>
                                      <td>{{item.observation}}</td>
                                  </tr>
                                  </tbody>
                              </table>
                          </div>
                          <div class="modal-footer">
                              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="col-sm-12 col-md-9">
              <div class="entradas-de-texto-govco">
                  <label for="Observaciones" class="form-label">Observaciones <span class="required">*</span></label>
                  <div class="container-input-texto-govco">
                      <textarea class="form-control" rows="3" id="Observaciones" aria-invalid="true"
                                aria-describedby="Observaciones-note"
                                formControlName="observation"
                                [ngClass]="{'error': isTouchedField(validationResultForm, 'observation')}"
                                placeholder="Observaciones" [value]="concatenacionObservaciones"> </textarea>
                    <span
                      class="error-texto-govco alert-entradas-de-texto-govco" id="observations-note" role="alert" aria-live="assertive">
                      {{ getErrorMessage('observation') }}
                    </span>
                  </div>
              </div>
          </div>
      </div>
  </div>
</form>
